import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {bindActionCreators} from 'redux'
import {LoaderRedux} from '../../components/LoaderRedux'
import SEModalsGeneracion from './Components/GeneracionFactura/Modals/SEModalsGeneracion'
import SEEncabezado from './Components/SEEncabezado'
import SEDatosCliente from './Components/GeneracionFactura/SEDatosCliente'
import SEDatosProducto from './Components/GeneracionFactura/SEDatosProducto'
import SETable1 from './Components/GeneracionFactura/SETable1'
import SEFooter from './Components/GeneracionFactura/SEFooter'
import {actionSujetoExcluidoEmision, actionsLogin} from '../../actions/action-creators'
import { BannerElegirSucursal } from '../../components/Banner/BannerElegirSucursal'
import { setActiveModuleDoc } from '../../actions/documentos/documentos.actions'
import DocumentosReceptor from '../../components/DocumentoReceptor/DocumentosReceptor'
import FormaPago from '../OtrosDocumentos/Components/FormaPago'
import { validateHorarioSucursal, validateUsoModulo } from '../../actions/general.actions'
import ObservacionesDocumentoBase from '../../components/ObservacionesDocumento/ObservacionesDocumento'
import { SUJETO_EXCLUIDO_TYPES } from '../../constants/sujetoExcluido.types'

const GeneracionSujetoExcluido = () => {
  const loader = useSelector((state: State) => state.general.loader)
  const {calculosArrayProductos, formObservaciones} = useSelector((state: State) => state.sujetoExcluido)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionSujetoExcluidoEmision, dispatch)
  const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
  const [loader2, setLoader2] = useState(false)

  useEffect(() => {
    dispatch(validateUsoModulo())
    dispatch(validateHorarioSucursal())
    dispatch(setActiveModuleDoc({idDoc: '14', title: 'Factura Sujeto Excluido'}));
    getSucursales()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSucursales = async () => {
    suscripcionGetFacturasDisponibles()
    await actions.sujetoExcluidoPostSucursales()
    setLoader2(false)
  }

  return (
    <>
      {!loader && loader2 && <LoaderRedux />}
      <SEModalsGeneracion />
      <SEEncabezado url='/otros-documentos' />
      <BannerElegirSucursal />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='dos-columnas-resp'>
            <SEDatosCliente />
            <SEDatosProducto />
          </div>
        </div>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card'>
            <div className='w-layout-vflex card-content'>
              <SETable1 />
              <FormaPago totalAPagar={calculosArrayProductos.totalPagar}/>
            </div>
          </div>
        </div>
        <ObservacionesDocumentoBase formObservaciones={formObservaciones} onChange={(field, value) => dispatch({ type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMOBSERVACIONES_HANDLE_CHANGE, payload: { [field]: value } })} />
        <DocumentosReceptor />
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card'>
            <div className='w-layout-vflex card-content'>
              <SEFooter />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GeneracionSujetoExcluido
